<template>
  <div class="location-form">
    <!--  Address Form -->
    <div class="mt-8 address">
      <FormulateForm>
        <textarea
          class="address-input"
          ref="address"
          :rows="values.address.length > 73 ? '3' : ''"
          placeholder="Address"
          :disabled="readonly"
          @input="setDefault"
          @blur="validateField"
          v-model="values.address" />
        <span v-if="readonly" @click="remove"><Close icon="close" width="10px" height="10px" /></span>
      </FormulateForm>
    </div>
    <div class="mt-2 mb-8">
      <span class="error" v-if="check && values.address && !values.lat && !values.lng">
        Please put a valid address {{values.lat}} {{values.lng}}
      </span>
    </div>

    <!-- Tags -->
    <Tags
      :data="tags"
      :value="type"
      @select="tagHandler"
    />
    <span class="error" v-if="values.address && values.lat && values.lng && !type"> Tag is Required</span>  


    <FormulateInput
      v-if="type == 'Other'"
      type="text"
      v-model="values.title"
      placeholder="Other Name" />
    <span class="error" v-if="type == 'Other' && values.address && type && !values.title"> Name is Required</span> 
  </div>
</template>
<script>
import Tags from '../Filters/Bullets.vue'
import Close from '../UI/Close.vue'
export default {
  components: {
    Tags,
    Close
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    this.initMap(),
    this.setTagsForUserLocation()
    if(this.form && this.form.address) {
      this.values = { ...this.form }
      if(this.form.id) {
        const data = this.$getState("userLocationTags")
        const flag = data.map(d => d.label).includes(this.values.title)
        this.type = flag ?  this.values.title : 'Other'
      }
    }
  },
  data () {
    return {
      values: {
        title: "",
        address: "",
        lat: null,
        lng: ""
      },
      check: false,
      type: '',
      autocomplete: null,
      readonly: false
    }
  },
  computed: {
    tags () {
      return this.$getState('userLocationTags') 
    },
    addressData () {
      return this.$getState('addressDetails')
    }
  },
  methods: {
    setDefault () {
      this.check = false
      this.values.lat = null
      this.values.lng = null
    },
    remove () {
      this.setDefault()
      this.values.address = ''
      this.readonly = false
      this.$setState('setIsCurrent', false)
    },
    validateField () {
      setTimeout(() => {
        this.check = true
      }, 500)
    },
    setTagsForUserLocation () {
      this.$setState('saveTagsForUserLocation')
    },
    tagHandler (data) {
      this.type = this.type == data.label ? '' : data.label
      this.values.title = this.type != 'Other' ? data.label : ''
    },
    initMap () {
      const input = this.$refs.address
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        fields: ["address_components", "geometry"]
      });
      google.maps.event.addListener(this.autocomplete, "place_changed", () => {
        let place = {
          address_components: [],
          ...this.autocomplete.getPlace()
        }
        this.values.lat = null
        this.values.lng = null
        this.extractAddress(place)
      })
    },
    extractAddress (place) {
      this.values.address = place.address || this.$refs['address'].value
      this.values.lat = place.lat || place.geometry.location.lat()
      this.values.lng = place.lng || place.geometry.location.lng()
      this.check = false
    }
  },
  watch: {
    values: {
      immediate: true,
      deep: true, 
      handler (data) {
        data.title = this.type == 'Other' ? data.title : this.type
        if(data.address && data.title && data.lat && data.lng) {
          this.$emit('save-form', this.values)
        } else {
          this.$emit('save-form', null)
        }
      }
    },
    addressData: {
      immediate: true,
      deep: true,
      handler (data) {
        if(data && this.$getState('isCurrent')) {
          this.readonly = true
          this.extractAddress(data)
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.address {
  position: relative;
  .close-btn {
    width: 24px;
    height: 24px;
    position: absolute;
    top: -5px;
    left: 98%;
  }
}
</style>